module.exports = __webpack_public_path__ + "img/user-default.5c6aa235.jpg";